
@if (ssoFlow) {
	<!-- =====================================================
		 SSO FLOW (/sso)
		 User is recognised by the IdP but has no Cohelion account.
		 Email verification is skipped — the wizard is shown directly.
	====================================================== -->
	<div class="wizard-with-close" data-cy="sso-wizard-container">
		<button class="close-button" type="button"
				(click)="goToLogin()" aria-label="Close">
			<i class="mdi mdi-close"></i>
		</button>
		@if (!wizardData) {
			<div class="validation-loading">
				<mat-spinner [diameter]="40"></mat-spinner>
			</div>
		}
		@if (wizardData) {
			<cs-wizard [dataContext]="wizardData"
					   [removesChrome]="true"></cs-wizard>
		}
	</div>

} @else if (!requireToken) {
	<!-- =====================================================
		 CHECK YOUR EMAIL FLOW (/access)
		 User submitted step-one; show confirmation message.
	====================================================== -->
	<div class="login-form-container check-email">
		<i class="mdi mdi-email-check-outline check-email__icon"></i>
		<button class="btn btn--primary btn--lg full-width" (click)="goToLogin()">
			{{ 'BACK_TO_LOGIN' | translate }}
		</button>
	</div>

} @else {
	<!-- =====================================================
		 EMAIL LINK FLOW (verify/:token)
		 User arrived via a tokenised email link.
		 We validate the token before showing the wizard.
	====================================================== -->

	@if (isValidatingToken) {
		<div class="validation-loading">
			<mat-spinner [diameter]="40"></mat-spinner>
			<p>{{ 'VALIDATING_TOKEN' | translate }}</p>
		</div>
	}

	@if (tokenError) {
		<div class="error-message">
			<p>{{ tokenError }}</p>
			<button mat-button (click)="goToRequestAccess()">
				{{ 'START_NEW_REQUEST' | translate }}
			</button>
		</div>
	}

	@if (!isValidatingToken && !tokenError) {
		<!-- Wizard Component Rendering the Form via Form-Generator NXT -->
		<div class="wizard-with-close">
			<button class="close-button" type="button"
					(click)="goToLogin()" aria-label="Close">
				<i class="mdi mdi-close"></i>
			</button>
			@if (wizardData) {
				<cs-wizard [dataContext]="wizardData"
						   [removesChrome]="true"></cs-wizard>
			}
		</div>
	}
}
